module.exports = __webpack_public_path__ + "static/media/bonus-move-made.3ef3d211.mp3";